module.exports = __webpack_public_path__ + "assets/img/69_313.d78d2f36.jpg";